export default (url: string): string => url.replace('https://', '').split('/').slice(1).join('/');
